import { DateTime } from "luxon";
import { Bugfender } from "@bugfender/sdk";
import store from "../store";
import { isProduction } from "./payment/Utilities";

class Logger {
  LogType = { Error: "Error", Warning: "Warning", Info: "Info" };

  log(category, message, url, logType, metaData, payMethod) {
    if (process.env.NODE_ENV != "production") {
      console.log(category, message, url, logType);
    }

    let nowDate = DateTime.local();
    const storeId =
      (store.getters.currentStoreDoc && store.getters.currentStoreDoc.ID) ||
      "udefined";
    Bugfender.setDeviceKey("StoreId", storeId);

    let val = {
      category: category || "unknown",
      desc: message || "",
      path: url || "",
      logType: logType,
      dateCreated: nowDate.toISODate(),
      metadata: metaData || {},
      payMethod: payMethod || "",
      storeId,
    };

    try {
      val.url = window.location.href;
      if (navigator.userAgent) val.userAgent = navigator.userAgent;
      switch (logType) {
        case this.LogType.Warning:
          Bugfender.sendLog({
            level: Bugfender.LogLevel.Warning,
            tag: storeId,
            text: JSON.stringify(val),
          });
          break;
        case this.LogType.Error:
          Bugfender.sendLog({
            level: Bugfender.LogLevel.Error,
            tag: storeId,
            text: JSON.stringify(val),
          });
          break;
        default:
          Bugfender.sendLog({
            level: Bugfender.LogLevel.Info,
            tag: storeId,
            text: JSON.stringify(val),
          });

          break;
      }
      if (!isProduction()) {
        console.warn(JSON.stringify(val));
      }
    } catch (e) {
      console.log("Error when writing to Bugfender\n" + e);
    }
  }
  logObject(obj, tag = "", level = Bugfender.LogLevel.Trace) {
    const storeId =
      (store.getters.currentStoreDoc && store.getters.currentStoreDoc.ID) ||
      "undefined";
    Bugfender.setDeviceKey("StoreId", storeId);

    Bugfender.sendLog({
      level: level,
      tag: tag || "general",
      text: JSON.stringify(obj),
    });
  }
}
export const logger = new Logger();
